import { render, staticRenderFns } from "./ViewerApp.vue?vue&type=template&id=767827dd"
import script from "./ViewerApp.vue?vue&type=script&lang=js"
export * from "./ViewerApp.vue?vue&type=script&lang=js"
import style0 from "./app.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports